import { socket } from '../core/socket.js';
import { t } from '../core/i18n.js';
import { chaosInput, popToast, chaosNotify } from '../utils/alerts.js';
import { naviguer } from './navigation.js';

// ==========================================================================
//   SIDEBAR TOGGLES
// ==========================================================================

export function toggleSidebarMenu() {
    const sidebar = document.getElementById('channels-column');
    sidebar.classList.toggle('closed');
    majPushChannels();
}

export function majPushChannels() {
    const sidebar = document.getElementById('channels-column');
    if (!sidebar) return;
    const visible = sidebar.style.display !== 'none';
    const ouvert = !sidebar.classList.contains('closed');
    document.body.classList.toggle('channels-open', visible && ouvert);
}

export function toggleAgents() {
    const sidebar = document.querySelector('.sidebar');
    const wrapper = document.getElementById('content-wrapper');
    sidebar.classList.toggle('collapsed');
    wrapper.classList.toggle('full-width');
}

// ==========================================================================
//   SOCIAL — RECHERCHE & BOÎTE DE RÉCEPTION
// ==========================================================================

export function rechercherAgent() {
    document.getElementById('modal-recherche-agent').style.display = 'flex';
}

export function fermerModaleRecherche() {
    document.getElementById('modal-recherche-agent').style.display = 'none';
}

export function toggleRequestInbox() {
    const inbox = document.getElementById('request-inbox');
    const display = window.getComputedStyle(inbox).display;
    inbox.style.display = (display === 'none') ? 'flex' : 'none';
}

export function ouvrirSphereSociale() {
    document.getElementById('social-badge').style.display = 'none';
    naviguer('social');
    socket.emit('demander-liste-amis');
    socket.emit('demander-liste-maj');
}

socket.on('erreur-sociale', (data) => {
    const msg = (data && data.key) ? t(data.key, data.params || {}) : String(data);
    chaosNotify(msg, t('alert.affiliation_error_title'), "alert");
});

socket.on('nouvelle-demande-ami', (expediteur) => {
    const badge = document.getElementById('social-badge');
    if (badge) badge.style.display = 'block';
    socket.emit('demander-liste-amis');
});

// ==========================================================================
//   DASHBOARD — ANIMATION SCRAMBLE
// ==========================================================================

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*";

export function startScramble(event) {
    let iteration = 0;
    const target = event.target;

    if (!target.dataset.original) {
        target.dataset.original = target.innerText;
    }

    const originalText = target.dataset.original;
    clearInterval(target.interval);

    target.interval = setInterval(() => {
        target.innerText = target.innerText
            .split("")
            .map((letter, index) => {
                if (index < iteration) return originalText[index];
                return letters[Math.floor(Math.random() * letters.length)];
            })
            .join("");

        if (iteration >= originalText.length) {
            clearInterval(target.interval);
            target.innerText = originalText;
        }
        iteration += 1 / 3;
    }, 30);
}

document.querySelectorAll(".scramble-text").forEach(title => {
    title.dataset.value = title.innerText;
    title.onmouseover = startScramble;
});

// ==========================================================================
//   MODALES — CHOIX DE SPHÈRE (créer / rejoindre)
// ==========================================================================

export function ouvrirModaleChoix() {
    document.getElementById('modal-choix-sphere').style.display = 'flex';
}

export function ouvrirCreationDirecte() {
    fermerToutesModales();
    document.getElementById('modal-container').style.display = 'flex';
}

export function ouvrirRejoindreDirecte() {
    fermerToutesModales();
    document.getElementById('modal-rejoindre-sphere').style.display = 'flex';
}

export function fermerToutesModales() {
    document.getElementById('modal-choix-sphere').style.display = 'none';
    document.getElementById('modal-rejoindre-sphere').style.display = 'none';
    document.getElementById('modal-container').style.display = 'none';
}

// ==========================================================================
//   CODE D'INVITATION
// ==========================================================================

export function envoyerCodeInvitation() {
    const input = document.getElementById('invite-code-input');
    const code = input.value.trim();
    if (code) {
        socket.emit('rejoindre-via-code', code);
        input.value = "";
    }
}

document.getElementById('invite-code-input')?.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') envoyerCodeInvitation();
});

export function construireLienInvitation(code) {
    return `${location.origin}${location.pathname}?invite=${encodeURIComponent(code)}`;
}

export function copierCode() {
    const input = document.getElementById('generated-invite-code');
    input.select();
    document.execCommand('copy');
    popToast(t('toast.code_copied'));
}

export function copierLienInvitation() {
    const input = document.getElementById('generated-invite-link');
    if (!input) return;
    input.select();
    document.execCommand('copy');
    popToast(t('toast.code_copied'));
}

socket.on('invitation-generee', (data) => {
    const modal = document.getElementById('modal-invitation-code');
    const input = document.getElementById('generated-invite-code');
    const lien  = document.getElementById('generated-invite-link');
    input.value = data.code;
    if (lien) lien.value = construireLienInvitation(data.code);
    modal.style.display = 'flex';
});

socket.on('code-valide', (data) => {
    fermerToutesModales();
    popToast(t('toast.code_join_ok'));
});

socket.on('erreur-chaos', (msg) => {
    popToast(t('alert.code_join_error', { msg }), 'error');
});

// ==========================================================================
//   GESTION DES DOSSIERS DE SPHÈRES (localStorage)
// ==========================================================================

export function chargerDossiers() {
    try { return JSON.parse(localStorage.getItem('sphere-folders') || '{}'); }
    catch (e) { return {}; }
}

export function _saveDossiers(d) {
    localStorage.setItem('sphere-folders', JSON.stringify(d));
    if (typeof window._pousserPrefs === 'function') window._pousserPrefs({ sphere_folders: d });
}

export function _setOrdreSpheres(arr) {
    localStorage.setItem('ordre-spheres', JSON.stringify(arr));
    if (typeof window._pousserPrefs === 'function') window._pousserPrefs({ sphere_order: arr });
}

export function creerDossier(idA, idB) {
    const d = chargerDossiers();
    const fid = 'folder-' + Date.now();
    d[fid] = { id: fid, name: 'Dossier', spheres: [String(idA), String(idB)], open: true };
    _saveDossiers(d);
    const ordre = JSON.parse(localStorage.getItem('ordre-spheres') || '[]').map(String);
    const positions = [ordre.indexOf(String(idA)), ordre.indexOf(String(idB))].filter(i => i !== -1).sort((a, b) => a - b);
    const newO = ordre.filter(x => x !== String(idA) && x !== String(idB));
    newO.splice(positions[0] ?? newO.length, 0, fid);
    _setOrdreSpheres(newO);
}

export function retirerDuDossier(fid, sid) {
    const d = chargerDossiers();
    if (!d[fid]) return;
    d[fid].spheres = d[fid].spheres.filter(x => x !== String(sid));
    const restant = [...d[fid].spheres];
    if (d[fid].spheres.length < 2) {
        delete d[fid];
        _saveDossiers(d);
        const ordre = JSON.parse(localStorage.getItem('ordre-spheres') || '[]').map(String);
        const idx = ordre.indexOf(fid);
        const newO = ordre.filter(x => x !== fid);
        newO.splice(idx !== -1 ? idx : newO.length, 0, String(sid), ...restant);
        _setOrdreSpheres(newO);
    } else {
        _saveDossiers(d);
        const ordre = JSON.parse(localStorage.getItem('ordre-spheres') || '[]').map(String);
        const idx = ordre.indexOf(fid);
        const newO = [...ordre];
        newO.splice(idx !== -1 ? idx + 1 : newO.length, 0, String(sid));
        _setOrdreSpheres(newO);
    }
}

export function toggleDossier(fid) {
    const d = chargerDossiers();
    if (!d[fid]) return;
    d[fid].open = !d[fid].open;
    _saveDossiers(d);
    document.getElementById('folder-members-' + fid)?.classList.toggle('open', d[fid].open);
}

// ==========================================================================
//   DOSSIERS, BADGES & TAGS DE SPHÈRES
// ==========================================================================

const FOLDER_COLORS = ['#f85149','#d29922','#e3b341','#3fb950','#2ea043','#58a6ff','#9a7de6','#f778ba','#79c0ff',null];
let _dossierContexte = null; 
const TAG_COLORS = ['#f85149','#d29922','#3fb950','#58a6ff','#9a7de6','#f778ba','#79c0ff','#e3b341'];
let _tagSphereId = null;
let _tagNewColor = TAG_COLORS[0];
let _badgeSphereActuelle = null;  
let _monBadgeActif       = false; 

export function _initFolderColorSwatches() {
    const container = document.getElementById('folder-color-swatches');
    if (!container || container.children.length) return;
    FOLDER_COLORS.forEach(color => {
        const sw = document.createElement('div');
        sw.className = 'color-swatch';
        sw.style.background = color || 'linear-gradient(135deg,var(--theme-primary),rgba(var(--theme-primary-rgb),0.3))';
        sw.title = color || 'Thème';
        sw.addEventListener('click', (e) => { e.stopPropagation(); changerCouleurDossier(color); });
        container.appendChild(sw);
    });
}

export function ouvrirMenuDossier(e, fid) {
    e.preventDefault();
    _dossierContexte = fid;
    document.querySelectorAll('.context-menu').forEach(m => m.style.display = 'none');
    const d = chargerDossiers()[fid];
    const current = d?.color || null;
    document.querySelectorAll('#folder-color-swatches .color-swatch').forEach((sw, i) => {
        sw.classList.toggle('selected', FOLDER_COLORS[i] === current);
    });
    const menu = document.getElementById('folder-context-menu');
    menu.style.display = 'block';
    menu.style.left = `${Math.min(e.clientX, window.innerWidth - 220)}px`;
    menu.style.top  = `${Math.min(e.clientY, window.innerHeight - menu.offsetHeight - 10)}px`;
}

export async function renommerDossierCtx() {
    document.getElementById('folder-context-menu').style.display = 'none';
    if (!_dossierContexte) return;
    const d = chargerDossiers()[_dossierContexte];
    const nom = await chaosInput('Nouveau nom du dossier :', 'RENOMMER', d?.name || 'Dossier');
    if (!nom) return;
    const dossiers = chargerDossiers();
    if (dossiers[_dossierContexte]) {
        dossiers[_dossierContexte].name = nom;
        _saveDossiers(dossiers);
        rendreListeSpheres(window.mesSpheresActuelles);
    }
}

export function changerCouleurDossier(color) {
    if (!_dossierContexte) return;
    const dossiers = chargerDossiers();
    if (!dossiers[_dossierContexte]) return;
    dossiers[_dossierContexte].color = color;
    _saveDossiers(dossiers);
    rendreListeSpheres(window.mesSpheresActuelles || []);
    // Fermer le menu et marquer la swatch sélectionnée
    document.getElementById('folder-context-menu').style.display = 'none';
    document.querySelectorAll('#folder-color-swatches .color-swatch').forEach((sw, i) => {
        sw.classList.toggle('selected', FOLDER_COLORS[i] === color);
    });
}

export async function dissoudreDossierCtx() {
    document.getElementById('folder-context-menu').style.display = 'none';
    if (!_dossierContexte) return;
    const ok = await chaosNotify('Les sphères seront remises dans la barre principale.', 'DISSOUDRE LE DOSSIER ?', 'confirm');
    if (!ok) return;
    const dossiers = chargerDossiers();
    const d = dossiers[_dossierContexte];
    if (!d) return;
    const ordre = JSON.parse(localStorage.getItem('ordre-spheres') || '[]').map(String);
    const idx = ordre.indexOf(_dossierContexte);
    const newO = ordre.filter(x => x !== _dossierContexte);
    newO.splice(idx !== -1 ? idx : newO.length, 0, ...d.spheres.map(String));
    _setOrdreSpheres(newO);
    delete dossiers[_dossierContexte];
    _saveDossiers(dossiers);
    rendreListeSpheres(window.mesSpheresActuelles);
}

function _getTagsSphere(sphereId) {
    const s = (window.mesSpheresActuelles || []).find(s => s.id == sphereId);
    return s?.tags || [];
}

function _updateTagsCache(sphereId, tags) {
    const s = (window.mesSpheresActuelles || []).find(s => s.id == sphereId);
    if (s) s.tags = tags;
}

export function ouvrirGestionnaireTags() {
    document.getElementById('custom-context-menu').style.display = 'none';
    _tagSphereId = state.sphereSelectionneeId;
    if (!_tagSphereId) return;
    _renderTagList();
    _renderTagColorSwatches();
    document.getElementById('tag-new-input').value = '';
    document.getElementById('tag-manager-modal').style.display = 'flex';
    setTimeout(() => document.getElementById('tag-new-input').focus(), 80);
}

export function fermerGestionnaireTags() {
    document.getElementById('tag-manager-modal').style.display = 'none';
    _tagSphereId = null;
    rendreListeSpheres(window.mesSpheresActuelles);
}

export function _renderTagList() {
    const container = document.getElementById('tag-list-container');
    container.innerHTML = '';
    const tags = _getTagsSphere(_tagSphereId);
    const sphere = (window.mesSpheresActuelles || []).find(s => s.id == _tagSphereId);
    const isAdmin = sphere?.mon_role === 'admin';
    const currentBadgeId = sphere?.badge_tag?.id || null;

    if (!tags.length) {
        const vide = document.createElement('p');
        vide.style.cssText = 'color:#8b949e;font-size:0.82rem;margin:4px 0 10px;';
        vide.textContent = "Aucun tag pour l'instant.";
        container.appendChild(vide);
        return;
    }
    tags.forEach(tag => {
        const row = document.createElement('div');
        row.className = 'tag-list-item';

        const pill = document.createElement('span');
        pill.className = 'tag-pill-preview';
        pill.textContent = tag.label;
        pill.style.background = tag.color;
        row.appendChild(pill);

        if (isAdmin) {
            const star = document.createElement('button');
            const isBadge = tag.id === currentBadgeId;
            star.className = 'tag-star-btn' + (isBadge ? ' active' : '');
            star.innerHTML = isBadge ? '★' : '☆';
            star.onclick = () => {
                socket.emit('definir-badge-sphere', { sphereId: _tagSphereId, tagId: isBadge ? null : tag.id });
            };
            row.appendChild(star);
        }

        const del = document.createElement('button');
        del.className = 'tag-delete-btn';
        del.innerHTML = '✕';
        del.onclick = () => supprimerTag(tag.id);
        row.appendChild(del);
        container.appendChild(row);
    });
}

export function _renderTagColorSwatches() {
    const container = document.getElementById('tag-new-color-swatches');
    container.innerHTML = '';
    TAG_COLORS.forEach(color => {
        const sw = document.createElement('div');
        sw.className = 'color-swatch' + (color === _tagNewColor ? ' selected' : '');
        sw.style.background = color;
        sw.onclick = () => {
            _tagNewColor = color;
            container.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('selected'));
            sw.classList.add('selected');
        };
        container.appendChild(sw);
    });
}

export function validerAjoutTag() {
    const label = document.getElementById('tag-new-input').value.trim();
    if (!label || !_tagSphereId) return;
    if (_getTagsSphere(_tagSphereId).length >= 5) { popToast('Maximum 5 tags par sphère', 'error'); return; }
    socket.emit('ajouter-tag-sphere', { sphereId: _tagSphereId, label, color: _tagNewColor });
    document.getElementById('tag-new-input').value = '';
}

export function supprimerTag(tagId) {
    if (!_tagSphereId) return;
    socket.emit('supprimer-tag-sphere', { tagId, sphereId: _tagSphereId });
}

export function _setSphereContexte(sphere) {
    _badgeSphereActuelle = sphere?.badge_tag || null;
    _monBadgeActif       = !!sphere?.mon_badge;
    _renderBadgeHeader();
}

export function _renderBadgeHeader() {
    const zone = document.getElementById('sphere-badge-zone');
    if (!zone) return;
    zone.innerHTML = '';
    if (!_badgeSphereActuelle) return;

    const pill = document.createElement('span');
    pill.className = 'sphere-badge-toggle' + (_monBadgeActif ? ' actif' : '');
    pill.textContent = _badgeSphereActuelle.label;
    pill.style.setProperty('--badge-color', _badgeSphereActuelle.color);
    pill.onclick = () => {
        socket.emit('toggle-badge-display', { sphereId: state.sphereActuelleID });
    };
    zone.appendChild(pill);
}

// Fonction d'initialisation réseau pour la Sidebar
export function initSidebarSync() {
    _initFolderColorSwatches();

    socket.on('sphere-tags-maj', ({ sphereId, tags }) => {
        _updateTagsCache(sphereId, tags);
        if (_tagSphereId == sphereId) _renderTagList();
        rendreListeSpheres(window.mesSpheresActuelles);
    });

    socket.on('sphere-badge-maj', ({ sphereId, badgeTag }) => {
        const s = (window.mesSpheresActuelles || []).find(s => s.id == sphereId);
        if (s) s.badge_tag = badgeTag;
        if (sphereId == state.sphereActuelleID) {
            _badgeSphereActuelle = badgeTag;
            _renderBadgeHeader();
        }
        if (_tagSphereId == sphereId) _renderTagList();
    });

    socket.on('mon-badge-maj', ({ sphereId, actif }) => {
        if (actif) {
            (window.mesSpheresActuelles || []).forEach(s => { if (s.id != sphereId) s.mon_badge = false; });
        }
        const s = (window.mesSpheresActuelles || []).find(s => s.id == sphereId);
        if (s) s.mon_badge = actif;
        _monBadgeActif = (sphereId == state.sphereActuelleID) ? actif : false;
        _renderBadgeHeader();
    });

    socket.on('user-badge-update', ({ pseudo, badge }) => {
        if (state.utilisateurs && state.utilisateurs[pseudo] !== undefined) {
            state.utilisateurs[pseudo].badge = badge;
            socket.emit('demander-liste-maj');
        }
    });
}

// ─── EXTENSION SIDEBAR : RENDU DES SPHÈRES & DRAG AND DROP (À METTRE TOUT EN BAS) ───

let _dragId = null;
let _dragInFolder = null;
let _folderTimer = null;
let _folderTarget = null;
let _folderLabel = null;

const _sphTooltip = document.getElementById('sphere-tooltip');
let _sphTooltipTimer = null;

function _showSphereTooltip(sphere, anchorEl) {
    clearTimeout(_sphTooltipTimer);
    if (!_sphTooltip) return;
    _sphTooltipTimer = setTimeout(() => {
        const tags = sphere.tags || [];
        _sphTooltip.innerHTML = '';

        const name = document.createElement('div');
        name.className = 'stt-name';
        name.textContent = sphere.nom;
        _sphTooltip.appendChild(name);

        if (sphere.description) {
            const desc = document.createElement('div');
            desc.className = 'stt-desc';
            desc.textContent = sphere.description;
            _sphTooltip.appendChild(desc);
        }

        if (tags.length) {
            const tagsRow = document.createElement('div');
            tagsRow.className = 'stt-tags';
            tags.forEach(tag => {
                const pill = document.createElement('span');
                pill.className = 'stt-tag';
                pill.textContent = tag.label;
                pill.style.background = tag.color;
                tagsRow.appendChild(pill);
            });
            _sphTooltip.appendChild(tagsRow);
        }

        const r = anchorEl.getBoundingClientRect();
        _sphTooltip.style.display = 'block';
        const ttW = _sphTooltip.offsetWidth;
        const ttH = _sphTooltip.offsetHeight;
        let left = r.right + 10;
        let top  = r.top + r.height / 2 - ttH / 2;
        if (left + ttW > window.innerWidth - 8) left = r.left - ttW - 10;
        if (top < 4) top = 4;
        if (top + ttH > window.innerHeight - 4) top = window.innerHeight - ttH - 4;
        _sphTooltip.style.left = left + 'px';
        _sphTooltip.style.top  = top  + 'px';
    }, 400);
}

function _hideSphereTooltip() {
    clearTimeout(_sphTooltipTimer);
    if (_sphTooltip) _sphTooltip.style.display = 'none';
}

function _clearFolderPropose() {
    clearTimeout(_folderTimer); _folderTimer = null;
    _folderTarget?.classList.remove('folder-propose');
    _folderTarget = null;
    _folderLabel?.remove(); _folderLabel = null;
}

function _startFolderPropose(targetBtn) {
    if (_folderTarget === targetBtn) return;
    _clearFolderPropose();
    _folderTarget = targetBtn;
    _folderTimer = setTimeout(() => {
        targetBtn.classList.add('folder-propose');
        _folderLabel = document.createElement('div');
        _folderLabel.className = 'folder-propose-label';
        _folderLabel.textContent = '📁 Créer un dossier';
        document.body.appendChild(_folderLabel);
        const r = targetBtn.getBoundingClientRect();
        _folderLabel.style.left = (r.right + 8) + 'px';
        _folderLabel.style.top = (r.top + r.height / 2 - 12) + 'px';
    }, 1500);
}

function _mkImg(src, alt) {
    const img = document.createElement('img');
    img.src = src; img.alt = alt;
    img.draggable = false;
    img.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:50%';
    return img;
}

export function creerBoutonSphere(sphere) {
    const btn = document.createElement('button');
    btn.className = 'sphere-icon draggable-sphere';
    btn.dataset.id = sphere.id;
    btn.draggable = true;
    btn.removeAttribute('title');

    if (sphere.icone_url) {
        btn.appendChild(_mkImg(sphere.icone_url, sphere.nom));
    } else if (sphere.icone && /\.(jpg|png)$/i.test(sphere.icone)) {
        btn.appendChild(_mkImg(`/img/spheres/${sphere.icone}`, sphere.nom));
    } else {
        btn.textContent = sphere.icone || '🌀';
        btn.style.fontSize = '24px';
    }

    btn.addEventListener('dragstart', (e) => {
        _dragId = String(sphere.id);
        _dragInFolder = btn.closest('.folder-members')?.closest('.sphere-folder-wrapper')?.dataset.folderId || null;
        e.dataTransfer.clearData();
        e.dataTransfer.setData('text/plain', String(sphere.id));
        e.dataTransfer.effectAllowed = 'move';
        setTimeout(() => btn.classList.add('dragging'), 0);
    });
    
    btn.addEventListener('dragend', () => {
        const wasFolderMember = !!_dragInFolder;
        const nowOutside = !btn.closest('.folder-members');
        btn.classList.remove('dragging');
        _clearFolderPropose();
        const savedFolderId = _dragInFolder;
        _dragId = null; _dragInFolder = null;
        if (wasFolderMember && nowOutside) {
            if (typeof retirerDuDossier === 'function') retirerDuDossier(savedFolderId, sphere.id);
            rendreListeSpheres(window.mesSpheresActuelles);
        } else {
            sauvegarderOrdreSpheres();
        }
    });
    
    btn.addEventListener('dragenter', (e) => {
        e.preventDefault();
        if (!_dragId || _dragId === String(sphere.id) || _dragId.startsWith('folder-')) return;
        _startFolderPropose(btn);
    });
    
    btn.addEventListener('dragleave', (e) => {
        if (_folderTarget === btn && !btn.contains(e.relatedTarget)) _clearFolderPropose();
    });
    
    btn.addEventListener('dragover', (e) => e.preventDefault());
    
    btn.addEventListener('drop', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (_folderTarget === btn && _dragId && !_dragId.startsWith('folder-') && _dragId !== String(sphere.id)) {
            const src = _dragId, srcFolder = _dragInFolder;
            _clearFolderPropose(); _dragId = null; _dragInFolder = null;
            if (srcFolder && typeof retirerDuDossier === 'function') retirerDuDossier(srcFolder, src);
            if (typeof creerDossier === 'function') creerDossier(src, sphere.id);
            rendreListeSpheres(window.mesSpheresActuelles);
        }
    });

    btn.onclick = () => {
        window.nomSphereActuelle = sphere.nom;
        if (typeof _setSphereContexte === 'function') _setSphereContexte(sphere);
        if (typeof window.naviguer === 'function') window.naviguer('sphere', { id: sphere.id, nom: sphere.nom });
    };
    
    btn.oncontextmenu = (e) => {
        e.preventDefault();
        window.sphereSelectionneeId = sphere.id;
        document.querySelectorAll('.context-menu').forEach(m => m.style.display = 'none');
        const isAdmin = sphere.mon_role === 'admin';
        const ctxTags = document.getElementById('ctx-menu-tags');
        if (ctxTags) ctxTags.style.display = isAdmin ? '' : 'none';
        const ctxDelete = document.getElementById('ctx-menu-delete-sphere');
        if (ctxDelete) ctxDelete.style.display = isAdmin ? '' : 'none';
        const menu = document.getElementById('custom-context-menu');
        if (menu) {
            menu.style.display = 'block';
            menu.style.left = `${Math.min(e.clientX, window.innerWidth - 200)}px`;
            menu.style.top  = `${Math.min(e.clientY, window.innerHeight - 120)}px`;
        }
    };

    btn.addEventListener('mouseenter', () => _showSphereTooltip(sphere, btn));
    btn.addEventListener('mouseleave', _hideSphereTooltip);

    _ajouterTouchDrag(btn, String(sphere.id));

    const wrapper = document.createElement('div');
    wrapper.className = 'sphere-btn-wrapper';
    wrapper.appendChild(btn);
    const badge = document.createElement('span');
    badge.className = 'sphere-notif-badge';
    badge.id = `sphere-badge-${sphere.id}`;
    badge.style.display = 'none';
    wrapper.appendChild(badge);
    return wrapper;
}

export function creerBoutonDossier(fid, fdata, spheresMap) {
    const outer = document.createElement('div');
    outer.className = 'sphere-folder-wrapper';
    outer.dataset.folderId = fid;

    const btn = document.createElement('button');
    btn.className = 'sphere-icon folder-icon draggable-sphere';
    btn.dataset.id = fid;
    btn.draggable = true;

    if (fdata.color) {
        btn.style.setProperty('--folder-bg-a',  fdata.color + '40');
        btn.style.setProperty('--folder-bg-b',  fdata.color + '12');
        btn.style.setProperty('--folder-border', fdata.color);
    }

    const stack = document.createElement('div');
    stack.className = 'folder-stack';
    fdata.spheres.slice(0, 3).forEach((sid, i) => {
        const dot = document.createElement('div');
        dot.className = 'folder-dot';
        dot.dataset.idx = i;
        const s = spheresMap[String(sid)];
        if (s?.icone_url) { dot.style.backgroundImage = `url(${s.icone_url})`; dot.style.backgroundSize = 'cover'; }
        else if (s?.icone && /\.(jpg|png)$/i.test(s.icone)) { dot.style.backgroundImage = `url(/img/spheres/${s.icone})`; dot.style.backgroundSize = 'cover'; }
        else { dot.textContent = s?.icone || '🌀'; }
        if (fdata.color) dot.style.setProperty('border-color', fdata.color + '80');
        stack.appendChild(dot);
    });
    btn.appendChild(stack);

    btn.addEventListener('dragstart', (e) => {
        _dragId = fid; _dragInFolder = null;
        e.dataTransfer.clearData();
        e.dataTransfer.setData('text/plain', fid);
        e.dataTransfer.effectAllowed = 'move';
        setTimeout(() => btn.classList.add('dragging'), 0);
    });
    btn.addEventListener('dragend', () => {
        _dragId = null; btn.classList.remove('dragging');
        _clearFolderPropose(); sauvegarderOrdreSpheres();
    });
    btn.onclick = () => { if (typeof toggleDossier === 'function') toggleDossier(fid); };
    btn.oncontextmenu = (e) => { e.preventDefault(); if (typeof ouvrirMenuDossier === 'function') ouvrirMenuDossier(e, fid); };
    btn.addEventListener('mouseenter', () => _showSphereTooltip({ id: fid, nom: fdata.name || 'Dossier' }, btn));
    btn.addEventListener('mouseleave', _hideSphereTooltip);

    const btnWrapper = document.createElement('div');
    btnWrapper.className = 'sphere-btn-wrapper';
    btnWrapper.appendChild(btn);
    outer.appendChild(btnWrapper);

    const membersDiv = document.createElement('div');
    membersDiv.className = 'folder-members' + (fdata.open ? ' open' : '');
    membersDiv.id = 'folder-members-' + fid;
    fdata.spheres.forEach(sid => {
        const s = spheresMap[String(sid)];
        if (s) membersDiv.appendChild(creerBoutonSphere(s));
    });
    outer.appendChild(membersDiv);

    return outer;
}

export function rendreListeSpheres(spheres) {
    const container = document.getElementById('dynamic-spheres');
    if (!container) return;
    container.innerHTML = '';

    const dossiers = typeof chargerDossiers === 'function' ? chargerDossiers() : {};
    const spheresMap = Object.fromEntries(spheres.map(s => [String(s.id), s]));
    const enDossier = new Set(Object.values(dossiers).flatMap(d => d.spheres.map(String)));
    let ordre = [];
    try { ordre = JSON.parse(localStorage.getItem('ordre-spheres') || '[]').map(String); } catch(e){}

    spheres.forEach(s => {
        const sid = String(s.id);
        if (!ordre.includes(sid) && !enDossier.has(sid)) ordre.push(sid);
    });

    ordre.forEach(itemId => {
        if (dossiers[itemId]) {
            container.appendChild(creerBoutonDossier(itemId, dossiers[itemId], spheresMap));
        } else if (spheresMap[itemId] && !enDossier.has(itemId)) {
            container.appendChild(creerBoutonSphere(spheresMap[itemId]));
        }
    });

    _initContainerDragDrop(container);
}

export function sauvegarderOrdreSpheres() {
    const container = document.getElementById('dynamic-spheres');
    if (!container) return;
    const ordre = [...container.children].map(el => {
        if (el.classList.contains('sphere-folder-wrapper')) return el.dataset.folderId;
        return el.querySelector('.draggable-sphere')?.dataset.id;
    }).filter(Boolean);
    if (typeof _setOrdreSpheres === 'function') _setOrdreSpheres(ordre);
}

function getDragAfterElement(container, y) {
    return [...container.children].reduce((closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) return { offset, element: child };
        return closest;
    }, { offset: Number.NEGATIVE_INFINITY }).element;
}

function _initContainerDragDrop(container) {
    if (container._dragDropInit) return;
    container._dragDropInit = true;
    container.addEventListener('dragover', (e) => {
        e.preventDefault();
        if (_folderTarget) return;
        const dragging = document.querySelector('.dragging');
        if (!dragging) return;
        const folderWrapper = dragging.closest('.sphere-folder-wrapper');
        const btnWrapper = dragging.closest('.sphere-btn-wrapper');
        const draggedOuter = folderWrapper || (btnWrapper?.parentElement === container ? btnWrapper : null);
        if (!draggedOuter || !container.contains(draggedOuter)) return;
        const after = getDragAfterElement(container, e.clientY);
        if (after == null) container.appendChild(draggedOuter);
        else container.insertBefore(draggedOuter, after);
    });
}

function _ajouterTouchDrag(btn, sphereId) {
    let pressTimer = null, dragging = false, clone = null;
    let hoverTimer = null, hoverTarget = null, folderReady = false;

    btn.addEventListener('touchstart', (e) => {
        pressTimer = setTimeout(() => {
            dragging = true;
            const touch = e.touches[0];
            clone = btn.cloneNode(true);
            clone.style.cssText = `position:fixed;left:${touch.clientX-24}px;top:${touch.clientY-24}px;width:48px;height:48px;z-index:99999;opacity:0.85;pointer-events:none;border-radius:50%;`;
            document.body.appendChild(clone);
            btn.classList.add('dragging');
        }, 1500);
    }, { passive: true });

    btn.addEventListener('touchmove', (e) => {
        if (!dragging) { clearTimeout(pressTimer); return; }
        e.preventDefault();
        const touch = e.touches[0];
        if (clone) { clone.style.left = (touch.clientX-24)+'px'; clone.style.top = (touch.clientY-24)+'px'; }

        clone.style.pointerEvents = 'none';
        const under = document.elementFromPoint(touch.clientX, touch.clientY);
        const targetBtn = under?.closest('.draggable-sphere:not(.dragging)');

        if (targetBtn && !targetBtn.dataset.isFolder && targetBtn.dataset.id !== sphereId) {
            if (hoverTarget !== targetBtn) {
                clearTimeout(hoverTimer);
                hoverTarget?.classList.remove('folder-propose');
                _folderLabel?.remove(); _folderLabel = null;
                hoverTarget = targetBtn; folderReady = false;
                hoverTimer = setTimeout(() => {
                    folderReady = true;
                    targetBtn.classList.add('folder-propose');
                    _folderLabel = document.createElement('div');
                    _folderLabel.className = 'folder-propose-label';
                    _folderLabel.textContent = '📁 Créer un dossier';
                    document.body.appendChild(_folderLabel);
                    const r = targetBtn.getBoundingClientRect();
                    _folderLabel.style.left = (r.right + 8) + 'px';
                    _folderLabel.style.top = (r.top + r.height / 2 - 12) + 'px';
                }, 1500);
            }
        } else if (hoverTarget) {
            clearTimeout(hoverTimer);
            hoverTarget.classList.remove('folder-propose');
            _folderLabel?.remove(); _folderLabel = null;
            hoverTarget = null; folderReady = false;
        }
    }, { passive: false });

    const _endTouchDrag = (e) => {
        clearTimeout(pressTimer);
        if (!dragging) return;
        dragging = false;
        clone?.remove(); clone = null;
        btn.classList.remove('dragging');
        clearTimeout(hoverTimer);
        _folderLabel?.remove(); _folderLabel = null;

        if (folderReady && hoverTarget) {
            const targetId = hoverTarget.dataset.id;
            hoverTarget.classList.remove('folder-propose');
            hoverTarget = null; folderReady = false;
            const myFolder = btn.closest('.folder-members')?.closest('.sphere-folder-wrapper')?.dataset.folderId;
            if (myFolder && typeof retirerDuDossier === 'function') retirerDuDossier(myFolder, sphereId);
            if (typeof creerDossier === 'function') creerDossier(sphereId, targetId);
            rendreListeSpheres(window.mesSpheresActuelles);
        } else {
            if (hoverTarget) { hoverTarget.classList.remove('folder-propose'); hoverTarget = null; }
            if (e.changedTouches) {
                const touch = e.changedTouches[0];
                const under = document.elementFromPoint(touch.clientX, touch.clientY);
                const container = document.getElementById('dynamic-spheres');
                const targetEl = under?.closest('.sphere-btn-wrapper, .sphere-folder-wrapper');
                const myWrapper = btn.closest('.sphere-btn-wrapper, .sphere-folder-wrapper');
                if (container && targetEl && container.contains(targetEl) && myWrapper && targetEl !== myWrapper) {
                    container.insertBefore(myWrapper, targetEl);
                }
            }
            sauvegarderOrdreSpheres();
        }
    };
    btn.addEventListener('touchend', _endTouchDrag);
    btn.addEventListener('touchcancel', _endTouchDrag);
}

// Intercepteur Socket.io à brancher à l'intérieur de initSidebarSync() chez toi
export function hookSpheresSockets() {
    socket.on('liste-spheres', (spheres) => {
        window.mesSpheresActuelles = spheres;
        rendreListeSpheres(spheres);
        if (window.sphereActuelleID) {
            const sphereCourante = spheres.find(s => s.id == window.sphereActuelleID);
            if (sphereCourante && typeof _setSphereContexte === 'function') _setSphereContexte(sphereCourante);
        }
    });
}

export function genererLien() {
    if (window.sphereActuelleID) {
        socket.emit('generer-invitation', window.sphereActuelleID);
    } else {
        if (typeof popToast === 'function') popToast(t('toast.no_sphere_active'), 'error');
    }
}